import { render, staticRenderFns } from "./SingleNumberFrame.vue?vue&type=template&id=f1b4ee1a&scoped=true&"
import script from "./SingleNumberFrame.vue?vue&type=script&lang=js&"
export * from "./SingleNumberFrame.vue?vue&type=script&lang=js&"
import style0 from "./SingleNumberFrame.vue?vue&type=style&index=0&id=f1b4ee1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b4ee1a",
  null
  
)

export default component.exports